import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40b165c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SearchDetail" }
const _hoisted_2 = { class: "Flex_Wrapper" }
const _hoisted_3 = { class: "Flex_Child_Half" }
const _hoisted_4 = { class: "Flex_Child_Half" }
const _hoisted_5 = { class: "Flex_Wrapper" }
const _hoisted_6 = { class: "Flex_Child_Half" }
const _hoisted_7 = { class: "Search_Contents" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Search_Contents_Title" }, "表示期間", -1))
const _hoisted_9 = { class: "Search_Contents_List" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"30px"} }, "～", -1))
const _hoisted_11 = { class: "check_container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contain_mukigen" }, "無期限を含む", -1))
const _hoisted_13 = { class: "check_container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contain_expired" }, "表示期間外を含む", -1))
const _hoisted_15 = ["disabled"]

import { ref, watch } from "vue";
import searchInputSyosi from "../molecules/searchInputSyosi.vue";
import { useStore } from "vuex";
import searchInputDate from "../molecules/searchInputDate.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchList',
  setup(__props, { expose: __expose }) {

const store = useStore();

const searchConditions = ref({
  syosiCd: "",
  fromRegisterDate: "",
  toRegisterDate: "",
  fromDisplayDate: "",
  toDisplayDate: "",
  containsMukigen: false,
  isExpired: false,
});
watch(searchConditions.value, () => {
  store.commit("search/setCreateListState", searchConditions.value);
});
// orderHeaderから条件リセットボタンが押されたときに発火
const resetConditions = () => {
  searchConditions.value.syosiCd = "";
  searchConditions.value.fromRegisterDate = "";
  searchConditions.value.toRegisterDate = "";
  searchConditions.value.fromDisplayDate = "";
  searchConditions.value.toDisplayDate = "";
  searchConditions.value.containsMukigen = false;
  searchConditions.value.isExpired = false;
};

__expose({
  resetConditions,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(searchInputSyosi, {
            title: '商品コード',
            initialData: searchConditions.value.syosiCd,
            onChange: _cache[0] || (_cache[0] = (newVal) => (searchConditions.value.syosiCd = newVal.syosiCd))
          }, null, 8, ["initialData"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(searchInputDate, {
            title: '登録日',
            initialFromData: searchConditions.value.fromRegisterDate,
            initialToData: searchConditions.value.toRegisterDate,
            onChange: _cache[1] || (_cache[1] = 
              (newFrom, newTo) => (
                (searchConditions.value.fromRegisterDate = newFrom),
                (searchConditions.value.toRegisterDate = newTo)
              )
            )
          }, null, 8, ["initialFromData", "initialToData"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchConditions.value.fromDisplayDate) = $event))
              }, null, 512), [
                [_vModelText, searchConditions.value.fromDisplayDate]
              ]),
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchConditions.value.toDisplayDate) = $event))
              }, null, 512), [
                [_vModelText, searchConditions.value.toDisplayDate]
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchConditions.value.containsMukigen) = $event)),
                  type: "checkbox",
                  name: "contain_mukigen",
                  id: "contain_mukigen"
                }, null, 512), [
                  [_vModelCheckbox, searchConditions.value.containsMukigen]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchConditions.value.isExpired) = $event)),
                  type: "checkbox",
                  name: "contain_expired",
                  id: "contain_expired",
                  disabled: 
                    searchConditions.value.fromDisplayDate !== '' &&
                    searchConditions.value.toDisplayDate !== ''
                  
                }, null, 8, _hoisted_15), [
                  [_vModelCheckbox, searchConditions.value.isExpired]
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})